import { DisplayOptions, NotifierRoles, Person, roleOptions } from "@/types";
import { quilterRoleOptions } from "@/types/quilter";
import { Property } from "@/types/property";

export function getRoleOptions(isQuilter: boolean): ReadonlyArray<DisplayOptions<NotifierRoles>> {
  if (!isQuilter) return roleOptions;
  return quilterRoleOptions;
}

export function isFinancialAdvisor(person: Person): boolean {
  return person.role === NotifierRoles.FinancialAdvisor;
}

export function notifierFieldRequired(field: keyof Person, record: Person) {
  switch (field) {
    case "isVulnerable":
    case "dateOfBirth":
    case "relationshipToDeceased":
      return !isSolicitorOrFinancialAdvisor(record.role as NotifierRoles);
  }
}

export function isSolicitorOrFinancialAdvisor(role: NotifierRoles | null | undefined): boolean {
  if (!role) return false;
  return [NotifierRoles.Solicitor, NotifierRoles.FinancialAdvisor].includes(role);
}

export function propertyDetails(
  propertyId: string | undefined,
  properties: ReadonlyArray<Property>
): string {
  if (!propertyId) {
    return "";
  }

  const property = properties.find((p) => p.id === propertyId);

  if (!property) {
    return "";
  }

  return `${property.address}, ${property.city}, ${property.postcode}`;
}
